import React, { useState, useEffect, useMemo, useRef } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Grid, InputBase, IconButton, Box, Badge, Typography, Drawer, FormControl, Button, ClickAwayListener } from "@material-ui/core";
import ChangeViewArray from '../ChangeViewArray';
import SearchIcon from '../../icons/SearchIcon';
import FilterIcon from '../../icons/FilterIcon';
import AddAllAppsIcon from '../../icons/AddAllAppsIcon';
import PropTypes from 'prop-types';
import AllProdsTable from "./AllProdsTable";
import AllProdsTile from "./AllProdsTile";
import AllProdsTbl from "./AllProdsTbl";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import translate from '../../other/translate.json';
import clsx from "clsx";
import CloseIcon from '../../icons/CloseIcon';
import SkeletonCardTable from '../Skeleton/SkeletonCardTable';
import SkeletonCardTile from '../Skeleton/SkeletonCardTile';
import SubFilterList from '../SubFilterListVers3';
import ProdDirectionSubFilterList from '../ProdDirectionSubFilterListVers3';
import ChipArrayRed from '../ChipArrayRed';
import Tooltip from '@material-ui/core/Tooltip';
import Pagination from '@material-ui/lab/Pagination';
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import FilterErr from "../Errors/FilterErr";
import config from '../../other/config';
import utils from "../../other/utils";
const FilterButton = withStyles({
	root: {
		width: '100%',
		borderRadius: '48px',
		boxShadow: 'none',
		textTransform: 'none',
		fontSize: '18px',
		border: 'none',
		lineHeight: '39px',
		backgroundColor: '#8987A2',
		borderColor: '#0063cc',
		fontFamily: 'Cera CY',
		color: '#FFFFFF',
		fontStyle: 'normal',

		'&:hover': {
			backgroundColor: '#8987A2',
		},
	},
})(Button);

export default function ProdListContent(props) {

	const { serverAPI } = config;
	const [countApp, setcountApp] = useState(0);
	const [page, setPage] = useState(1);
	const classes = useStyles();
	const [searchFocus, setSearchFocus] = useState(false);
	const [filterOpen, setFilterOpen] = useState(false);
	const [screenDirectionVisible, setScreenDirectionVisible] = useState(false);
	const [screenVersionBeforeVisible, setScreenVersionBeforeVisible] = useState(false);
	const [screenActionsBeforeVisible, setScreenActionsBeforeVisible] = useState(false);
	// const [cardArr, setCardArr] = useState([]);
	const [cardArrAll, setCardArrAll] = useState([]);
	const [BranchArr, setBranchArr] = useState([]);
	const [GroupArr, setGroupArr] = useState([]);
	const [DirectionArr, setDirectionArr] = useState([]);
	const [loading, setloading] = useState(true);
	const [snackbar, _snackbar] = React.useState([false, '']);
	const language = localStorage.getItem('language') || 'Ru';
	const [pageTbl, setPageTbl] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [init, _init] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [findText, setFindText] = useState('');
	const [SelectGroup, _SelectGroup] = useState([]);
	const [SelectDirection, _SelectDirection] = useState([]);
	const [SelectBranch, _SelectBranch] = useState([]);
	const [statusFilter, setStatusFilter] = useState(false);
	const [allCheckBox, setAllCheckBox] = useState(false);
	const [checkAll, setCheckAll] = useState(false);
	const history = useHistory()
	const [view, _view] = useState(localStorage.getItem('view') || 'table');
	const [rusSearch, _rusSearch] = useState('');

	// async function getArrCard(language, page, SelectDirection, idsGroup, SelectBranch) {
	// 	return await axios.get(`${serverAPI}/prod/${language}?page=${page}&search=${findText}&countRecord=24&actions=${SelectDirection}&group=${idsGroup}&subgroup=${SelectBranch}&sort=Title_Ru`);
	// }
	async function getArrCardID(language, page, SelectDirection, idsGroup, SelectBranch) {
		return await axios.post(`${serverAPI}/prodall/${window.location.pathname.split('/')[2]}/${language}?page=${page}&search=${encodeURIComponent(utils.validateSearchVal(findText))}&countRecord=&sort=Title_Ru&inCu=${props.userCollection.inCu}`, { actions: SelectDirection, group: idsGroup, subgroup: SelectBranch });
	}

	const getRelevantNumEqualProd = (a) => {
		let need = a.AppsCodeNeeded.toUpperCase();
		let aTitle = a.Title.toUpperCase();
		let search = findText.toUpperCase();
		let recomended = a.AppsCodeRecommended.toUpperCase();
		// let aDesc = a.briefdescription.toUpperCase() + a.HTMLFunction.toUpperCase() + a.HTMLContent.toUpperCase();
		let result = 10;
		if (need.indexOf(search) > -1) {
			result = 10000;
		} else if (recomended.indexOf(search) > -1) {
			result = 1000;
		} else if (aTitle === search) {
			result = 500;
		} else if (a.findAppName === 1) {
			result = 100;

		}
		return result

		/**По коду Приложения - вхождение в состав Продукта как необходимое
По коду Приложения - вхождение в состав Продукта как рекомендуемое
По точному наименованию Продукта
По точному наименованию входящих в состав Продукта Приложений
По ключевым словам (поиск по текстовым полям, см.п.1) */

	}

	const compareTitles = (a, b) => {
		if (b.Title > a.Title) {
			return -1
		}
		if (b.Title < a.Title) {
			return 1
		}
		return 0
	}

	function changePage(event, value) {
		//setloading(true)
		setPage(value);
		window.scrollTo(0, 0);
	};

	const setView = (index) => {
		if (index === 'tbl')
			// Arh 
			setPage(1);
		setPageTbl(0);
		_view(index)
		localStorage.setItem('view', index)
	}

	function closeSnackbar(event, reason) {
		if (reason === 'clickaway') {
			return;
		}

		_snackbar([false, '']);
	};

	const getFiltersParams = (selectAreaF = '', selectGroupF = '', selectSubgroupF = '') => {
		if (selectAreaF !== '') {
			return { areaQuery: '', groupQuery: '&area=', subGroupQuery: '' }
		} else if (selectGroupF !== '') {
			return { areaQuery: '', groupQuery: '', subGroupQuery: '' }
		} else if (selectSubgroupF !== '') {
			return { areaQuery: '', groupQuery: '', subGroupQuery: '' }
		}
		return { areaQuery: '', groupQuery: '', subGroupQuery: '' }

	};

	//  ---------------Первоначальная загрузка фильтров-------------------------------------------------------------------------------------------------
	useEffect(() => {
		setloading(true)
		let didCancel = false;
		async function fetchData() {
			let products = await getProducts()
			let selectAreaF = getParamURLQuery(history.location.search, 'area')
			let selectGroupF = getParamURLQuery(history.location.search, 'group')
			let selectSubgroupF = getParamURLQuery(history.location.search, 'subgroup')
			const directionAll = await axios.get(`${serverAPI}/prod_direction/${window.location.pathname.split('/')[2]}?lang=${language}`)
			const groupAll = await axios.get(`${serverAPI}/prod_group/${window.location.pathname.split('/')[2]}?lang=${language}`)
			const branchAll = await axios.get(`${serverAPI}/prod_subgroup/${window.location.pathname.split('/')[2]}?lang=${language}`)
			const isAllrecords = selectAreaF === '' && selectGroupF === '' && selectSubgroupF === '';
			let directions = directionAll.data || [];
			let groups = groupAll.data || [];
			let subgroups = branchAll.data || [];

			if (selectAreaF !== '') {
				let allProducts = products.filter(elem => elem.P_DirectionsID === +selectAreaF)//.map(elem => elem)
				groups = groups.filter(elem => allProducts.map(el => el.P_GroupID).includes(elem.ID));
				subgroups = subgroups.filter(elem => allProducts.map(el => el.SubGroupTitle).includes(elem[`Title${language}`]));
			}
			if (selectGroupF !== '') {
				let allProducts = products.filter(elem => elem.P_GroupID === +selectGroupF)
				subgroups = subgroups.filter(elem => allProducts.map(el => el.SubGroupTitle).includes(elem[`Title${language}`]));
				directions = directions.filter(elem => allProducts.map(el => el.P_DirectionsID).includes(elem.ID));
			}
			if (selectSubgroupF !== '') {
				let allProducts = products.filter(elem => decodeURI(selectSubgroupF) === elem.SubGroupTitle);
				directions = directions.filter(elem => allProducts.map(el => el.P_DirectionsID).includes(elem.ID));
				groups = groups.filter(elem => allProducts.map(el => el.P_GroupID).includes(elem.ID));
			}
			setBranchArr(subgroups)
			setGroupArr(groups)
			setDirectionArr(directions)

			console.warn("firstcall", selectGroupF && +selectGroupF > 0, selectGroupF, +selectGroupF, selectAreaF && +selectAreaF > 0, selectAreaF, +selectAreaF)
			if (selectGroupF !== '') _SelectGroup(groupAll.data.filter(el => el.ID === +selectGroupF))
			if (selectAreaF !== '') _SelectDirection(directionAll.data.filter(el => el.ID == +selectAreaF))
			if (selectSubgroupF !== '') {
				_SelectBranch(branchAll.data.filter(el => el[`Title${language}`] === decodeURI(selectSubgroupF)))
			}
			setloading(false)

			_init(true)

		}
		if (!didCancel) {
			fetchData();
		}
		return () => {

			didCancel = true;
		};
	}, []);

	useEffect(() => {
		setloading(true)
		let didCancel = false;
		async function fetchData() {
			if (!didCancel && init !== false) {
				console.warn("4call")
				const branchAll_filtred = await axios.get(`${serverAPI}/prod_subgroup?lang=${language}&action=${SelectDirection.map(el => el.ID)}&group=${SelectGroup.map(el => el.ID)}&subgroup=${SelectBranch.map(el => el.ID)}`)
				const groupAll_filtred = await axios.get(`${serverAPI}/prod_group?lang=${language}&action=${SelectDirection.map(el => el.ID)}&group=${SelectGroup.map(el => el.ID)}&subgroup=${SelectBranch.map(el => el.ID)}`)
				console.warn("4call-2")
				setBranchArr(branchAll_filtred.data)
				setGroupArr(groupAll_filtred.data)
			}
		}
		fetchData();
		return () => {
			setPage(1)
			setPageTbl(0)
			setloading(false)
			didCancel = true;
		};
	}, [SelectDirection]);

	useEffect(() => {
		setloading(true)
		let didCancel = false;
		async function fetchData() {
			if (!didCancel && init !== false) {
				console.warn("secondcall")
				const branchAll_filtred = await axios.get(`${serverAPI}/prod_subgroup?lang=${language}&action=${SelectDirection.map(el => el.ID)}&group=${SelectGroup.map(el => el.ID)}&subgroup=${SelectBranch.map(el => el.ID)}`)
				const direction_filtred = await axios.get(`${serverAPI}/prod_direction?lang=${language}&action=${SelectDirection.map(el => el.ID)}&group=${SelectGroup.map(el => el.ID)}&subgroup=${SelectBranch.map(el => el.ID)}`)

				setBranchArr(branchAll_filtred.data)
				setDirectionArr(direction_filtred.data)
			}
		}
		fetchData();
		return () => {
			setPage(1)
			setPageTbl(0)
			setloading(false)
			didCancel = true;
		};
	}, [SelectGroup]);

	useEffect(() => {
		setloading(true)
		let didCancel = false;
		async function fetchData() {
			if (!didCancel && init !== false) {
				console.warn("thirdcall")
				const groupAll_filtred = await axios.get(`${serverAPI}/prod_group?lang=${language}&action=${SelectDirection.map(el => el.ID)}&group=${SelectGroup.map(el => el.ID)}&subgroup=${SelectBranch.map(el => el.ID)}`)
				const direction_filtred = await axios.get(`${serverAPI}/prod_direction?lang=${language}&action=${SelectDirection.map(el => el.ID)}&group=${SelectGroup.map(el => el.ID)}&subgroup=${SelectBranch.map(el => el.ID)}`)
				setGroupArr(groupAll_filtred.data)
				setDirectionArr(direction_filtred.data)
			}
		}
		fetchData();
		return () => {
			setPage(1)
			setPageTbl(0)
			setloading(false)
			didCancel = true;
		};
	}, [SelectBranch]);

	const resetState = () => {
		_init(false)
		setloading(true)
		history.push({
			search:
				`${history.location.search = '?filt=true'}`
		})
		_SelectGroup([])
		_SelectDirection([])
		_SelectBranch([])
		setFindText('')
		setSearchText('')
		setPage(1)
		setPageTbl(0)
		getFilters(true)

	}

	useEffect(() => {
		//setloading(true)
		setStatusFilter(SelectDirection.length > 0 || SelectGroup.length > 0 || SelectBranch.length > 0)
		let didCancel = false;
		const fetchData = async () => {
			if (!didCancel && init !== false) {
				getProducts()
			}
		}
		fetchData();
		return () => {

			didCancel = true;
		};
	}, [/*page,*/ SelectDirection, SelectGroup, SelectBranch, findText]);

	const getProducts = async (resetState = false) => {
		return new Promise(async (resolve, reject) => {
			setloading(true)
			_rusSearch('')
			let sdQuery = init === false ? getParamURLQuery(history.location.search, 'area') : SelectDirection.map(el => el.ID).join(',');
			let sgQuery = init === false ? getParamURLQuery(history.location.search, 'group') : SelectGroup.map(el => el.ID).join(',');
			let sbQuery = init === false ? decodeURIComponent(getParamURLQuery(history.location.search, 'subgroup')) : SelectBranch.map(el => language == 'Ru' ? `${el.TitleRu}` : `${el.TitleEn}`).join(',');
			if (resetState) {
				sdQuery = '';
				sgQuery = '';
				sbQuery = '';
			}
			// console.log(sbQuery)
			let ArrCardID = await getArrCardID(language, page - 1, sdQuery, sgQuery, sbQuery !== '' ? sbQuery : '', findText)
			if (ArrCardID && ArrCardID.data)
				setloading(false)
			if (findText && findText.length > 2) {
				ArrCardID.data.records = ArrCardID.data.records.sort(compareTitles).map(el => { el.relev = getRelevantNumEqualProd(el); return el }).sort(/*sortSearchReasultByRelevant*/(a, b) => b.relev - a.relev)//.sort(sortSearchReasultProdByRelevant)
			}
			setcountApp(ArrCardID.data.records.length)
			setCardArrAll(ArrCardID.data.records)
			if (ArrCardID.data.searchValue !== '' && ArrCardID.data.searchValue !== undefined) {
				_rusSearch(ArrCardID.data.searchValue)
			}
			resolve(ArrCardID.data.records)
		})

	}
	// Мониторим ширину окна браузера
	useEffect(() => {
		if (window.innerWidth < 1366 && (view === 'tbl')
			//  && window.innerWidth > 1366 && (view === 'tbl')
		) {
			setView('tile')
		}
	}, [window.innerWidth]);

	function getParamURLQueryGroup(srt, param) {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			if (param === 'group=') {
				return (Val)
			}
		}
	}

	function getParamURLQuerySubgroup(srt, param) {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			if (param === 'subgroup=') {
				// _SelectBranch(SelectBranch.push(Val))
				return (Val)
			}
		}
	}

	function getParamURLQueryArea(srt, param) {
		let arr = srt.split('&')
		let res1 = arr.filter(el => el.includes(param))
		let Val = res1[0].split('=')[1];
		if (res1 && res1[0] && Val) {
			if (param === 'area=') {
				// _SelectBranch(SelectBranch.push(Val))
				return (Val)
			}
		}
	}
	function getParamURLQuery(srt, param, needQuotes = false) {
		try {
			let arr = srt.replace('?', '&').split('&')
			let res1 = arr.filter(el => el.includes(param))
			let Val = res1[0].split('=')[1];
			if (res1 && res1[0] && Val) {
				if (param === res1[0].split('=')[0]) {
					// _SelectBranch(SelectBranch.push(Val))
					return needQuotes ? `'${Val}'` : (Val)
				}
			}
			return ''
		} catch (e) {
			return ''
		}
	}

	const getFilters = async (resetState) => {
		const directionAll = await axios.get(`${serverAPI}/prod_direction?lang=${language}`)
		const groupAll = await axios.get(`${serverAPI}/prod_group?lang=${language}`)
		const branchAll = await axios.get(`${serverAPI}/prod_subgroup?lang=${language}`)
		setBranchArr(branchAll.data)
		setGroupArr(groupAll.data)
		setDirectionArr(directionAll.data)
		await getProducts(resetState)
		_init(true)
		setloading(false)
	}

	function clearSearch() {
		history.push({ search: `${history.location.search.replace(/&search=(%?\w|\d)+/, '')}` })
		setSearchFocus(false);
		setSearchText('');
		setFindText('')
		textInput.current.firstChild.value = ''
	}

	function handleKeyDown(event, val) {
		if (event.key === 'Enter' && val !== "") {
			setloading(true)
			setFindText(val)
			setPage(1)
		}
	}


	useEffect(() => {
		if (window.innerWidth < 1366 && view === 'table') {
			setView('tile')
		}
	}, [window.innerWidth]);

	function setDirection(direction_) {
		setPage(1)
		if (SelectDirection.some(el => el.ID === direction_.ID)) {
			_SelectDirection(SelectDirection.filter(el => el.ID !== direction_.ID))
		} else {
			_SelectDirection(SelectDirection.concat([direction_]))
		}
	}

	function setGroup(group_) {
		console.warn("function setGroup")
		setPage(1)
		if (SelectGroup.some(el => el.ID === group_.ID)) {
			_SelectGroup(SelectGroup.filter(el => el.ID !== group_.ID))
		} else {
			_SelectGroup(SelectGroup.concat([group_]))
		}
	}

	function setSelectBranch(SelectBranch_) {
		// setPage(1)
		if (language == 'Ru') {
			if (SelectBranch.some(el => el.TitleRu === SelectBranch_.TitleRu)) {
				_SelectBranch(SelectBranch.filter(el => el.TitleRu !== SelectBranch_.TitleRu))
			} else {
				_SelectBranch(SelectBranch.concat([SelectBranch_]))
			}
		} else {
			if (SelectBranch.some(el => el.TitleEn === SelectBranch_.TitleEn)) {
				_SelectBranch(SelectBranch.filter(el => el.TitleEn !== SelectBranch_.TitleEn))
			} else {
				_SelectBranch(SelectBranch.concat([SelectBranch_]))
			}
		}
	}

	function removeSubFroup(chipToDelete) {  // https://pikabu.ru/story/furafic_fark_5732754
		_SelectBranch(SelectBranch.filter(el => el !== chipToDelete))
	};

	function handleDeleteVers(chipToDelete) {
		_SelectGroup(SelectGroup.filter(el => el !== chipToDelete))
	}

	function handleDeleteActions(chipToDelete) {
		_SelectDirection(SelectDirection.filter(el => el !== chipToDelete))
	}

	const renderSearchInfo = () => {
		if (rusSearch !== '' && language === 'Ru') {
			return (
				<Typography className={classes.FoundProds}>По запросу "{findText}" ничего не найдено. Показаны результаты по запросу "{rusSearch}".
					<br /> {translate.Words[`FoundProds${language}`]}{cardArrAll.length}</Typography>
			)
		} else {
			return (
				<Typography className={classes.FoundProds}>{translate.Words[`FoundProds${language}`]}{cardArrAll.length}</Typography>
			)
		}
	}

	function FilterHeader() {
		return (
			<Grid container direction="row" justify="space-between" alignItems="center" style={{ padding: '12px 12px 12px 24px' }} /* style={{ position: 'fixed', width: 334, background: '#FFF', paddingTop: 32, paddingLeft: 24, zIndex: 2 }} */>
				<Grid item>
					<Typography className={classes.filterHeader}>
						{translate.Words[`Filter${language}`]}
					</Typography>
				</Grid>

				<Grid item className={classes.btnClose}>
					<IconButton onClick={() => setFilterOpen(false)} aria-label="filter">
						<CloseIcon fill='#BCBBD0' />
					</IconButton>
				</Grid>
			</Grid>
		)
	};

	function uniqueArr(arr) {
		let result = [];

		for (let str of arr) {
			if (!result.includes(str)) {
				result.push(str);
			}
		}

		return result;
	}

	async function choiseAll(event) {
		const ArrCardID = await getArrCardID(language, 0, SelectDirection.map(el => el.ID).join(','), SelectGroup.map(el => el.ID).join(','), SelectBranch.map(el => el.TitleRu).join(','), findText)
		let basketProd = props.userCollection.productBasket;
		let newProdID = ArrCardID && ArrCardID.data && ArrCardID.data.records && ArrCardID.data.records.filter(el => !basketProd.includes(el.ID)).map(el => { return { id: el.ID, apps: [el.AppsIDsNeeded.replace(' ', '').split(',').map(el => +el).concat(el.AppsIDsRecommended.replace(' ', '').split(',').map(el => +el))] } })
		// let newCardID = ArrCardID && ArrCardID.data

		if (allCheckBox === true) {

			setCheckAll(!checkAll)
		} else {
			props.saveCollection(newProdID, 'product', 'cart', undefined, true);
			setCheckAll(!checkAll)
			//let basketProd1 = basketProd.filter(item => newProdID.includes(item))
			_snackbar([true, newProdID.length])
		}
	}

	useEffect(() => {
		let basketProd = props.userCollection.productBasket || []
		let isAll = cardArrAll.every(el => basketProd.includes(el.ID))
		setAllCheckBox(isAll)
	}, [cardArrAll, checkAll, props.userCollection.productBasket]);
	const textInput = useRef(null);
	function ApplicationsContent() {

		if (view === 'table') {
			if (loading === true) {
				return (<SkeletonCardTile />)
			} else {
				if (cardArrAll.length === 0) {
					return (
						<FilterErr />
					)
				} else {
					return (
						<AllProdsTile
							setCheckAll={setCheckAll}
							checkAll={checkAll}
							cardArr={cardArrAll.filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
							userCollection={props.userCollection}
							saveCollection={props.saveCollection}
						/>
					)
				}
			}
		} else {
			if (view === 'tile') {
				if (loading === true) {
					return (<SkeletonCardTable />)
				} else {
					if (cardArrAll.length === 0) {
						return (
							<FilterErr />
						)
					} else {
						return (
							<AllProdsTable
								setCheckAll={setCheckAll}
								cardArr={cardArrAll.filter((elem, index) => { return index < page * 24 && index >= (page - 1) * 24 })}
								checkAll={checkAll}
								loading={loading}
								userCollection={props.userCollection}
								saveCollection={props.saveCollection}
							/>
						)
					}
				}
			}

			if (view === 'tbl') {
				if (cardArrAll.length === 0 && !loading) {
					return (
						<FilterErr />
					)
				} else {
					return (
						<AllProdsTbl
							setCheckAll={setCheckAll}
							cardArr={cardArrAll}
							checkAll={checkAll}
							type={'products'}
							loading={loading}
							page={pageTbl}
							setPage={setPageTbl}
							rowsPerPage={rowsPerPage}
							setRowsPerPage={setRowsPerPage}
							userCollection={props.userCollection}
							saveCollection={props.saveCollection}
						/>
					)
				}
			}
		}
	}

	return (
		<React.Fragment>
			<Grid container spacing={3} style={{ marginTop: 40 }}>
				<Grid item container alignItems="center">
					<Grid item container>
						<Grid
							item
							// key={props.ml}
							className={classes.search}
							style={{
								background: searchFocus ? '#fff' : '#EEEEF5',
								boxShadow: searchFocus ? '6px 6px 18px rgba(35, 72, 152, 0.08)' : undefined,
							}}
						>
							<div className={classes.searchIcon}>
								<SearchIcon fill={'#BCBBD0'} />
							</div>

							<ClickAwayListener onClickAway={(e) => { setSearchFocus(false) }}>
								<InputBase
									onKeyDown={(e) => handleKeyDown(e, e.target.value)}
									//value={searchText}
									//onChange={(e) => setSearchText(e.target.value)}
									ref={textInput}
									placeholder={translate.Words[`ProductSearch${language}`]}
									classes={{
										root: classes.inputRoot,
										focused: classes.inputFocused,
										input: classes.inputInput
									}}

									inputProps={{ 'aria-label': 'search' }}
									onFocus={() => setSearchFocus(true)}
								/>
							</ClickAwayListener>

							{/* НИЖЕ КНОПКА ОЧИЩЕНИЯ СТРОКИ ПОИСКА */}
							<IconButton aria-label="add to favorites"
								onClick={() => clearSearch()}

								className={clsx(classes.inputCloseBtn, {
									[classes.inputCloseBtnHide]: searchFocus === false
								})}
							>
								<CloseIcon fill={'#BCBBD0'} />
							</IconButton>
						</Grid>

						<Grid item style={{ paddingRight: 24 }}>
							<Button aria-label="delete" className={classes.margin} size="small" onClick={(e) => choiseAll(e)} style={{ height: 48, display: allCheckBox ? 'none' : '' }}>
								<AddAllAppsIcon fill={'#BCBBD0'} fontSize="inherit" />

								<Typography style={{ marginLeft: 16, color: '#8987A2', textTransform: 'none' }}>{translate.Words[`AddAllToBasket${language}`]}</Typography>
							</Button>
						</Grid>

						<Grid item className={classes.cntrChangeView}>
							{/* <ChangeViewArray selected={view === 'tile' ? 1 : view === 'table' ? 0 : 2} page={'applist'} handleView={handleStrockList} /> */}
							<ChangeViewArray
								selected={view === 'tile' ? 1 : view === 'table' ? 0 : 2}
								handleView={setView}
								// handleCount={setRecord}
								page={window.innerWidth > 1365 ? 'applist' : ''}
							/>
						</Grid>

						{/* ===== ФИЛЬТРЫ =============== */}

						<Grid item>
							<CustomTooltip title={language === 'Ru' ? 'Фильтр' : "Filter"}>
								<IconButton onClick={() => setFilterOpen(true)} aria-label="filter" className={classes.btnFilter}>
									{statusFilter ?
										<StyledBadge
											color="secondary"
											variant="dot"
										>
											<FilterIcon />
										</StyledBadge>
										:
										<FilterIcon />}
								</IconButton>
							</CustomTooltip>

							<Drawer
								anchor={"right"}
								open={filterOpen}
								onClose={() => setFilterOpen(false)}
							// className={classes.root}
							>
								<Grid item className={classes.FilterHeaderCntr} style={{ width: 334 }}>
									{FilterHeader()}
								</Grid>

								<Grid style={{ height: 'calc(100% - 108px)', overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}>
									<Grid item container direction="column" style={{ padding: '0 24px', height: '100%' }}>
										<Grid item container direction="column" className={classes.FilterBodyCntr}>
											<FormControl component="fieldset" style={{ maxWidth: 285, width: '100%' }}>
												<Typography className={classes.header}>{translate.Words[`Direction${language}`]}:</Typography>

												<SubFilterList
													data={DirectionArr}
													ids={SelectDirection}
													key1={'ID'}
													key2={'Title'}
													setBefore={setDirection}
													header={translate.Words[`Direction${language}`]}
													paramName='Actions'
													close={() => setScreenActionsBeforeVisible(!screenActionsBeforeVisible)}
												/>

												{SelectDirection && SelectDirection.length > 0 ?
													<Grid item style={{ paddingTop: 8 }}>
														<ChipArrayRed chipData={SelectDirection} key1={'ID'} key2={`Title`} handleDelete={handleDeleteActions} />
													</Grid> : ''}
											</FormControl>

											<FormControl component="fieldset" style={{ maxWidth: 285, width: '100%' }}>
												<Typography className={classes.header}>{translate.Words[`Group${language}`]}:</Typography>

												<SubFilterList
													data={GroupArr}
													ids={SelectGroup}
													key1={'ID'}
													key2={'Title'}
													setBefore={setGroup}
													header={translate.Words[`Group${language}`]}
													paramName='group'
													close={() => setScreenVersionBeforeVisible(!screenVersionBeforeVisible)}
												/>

												<Grid item style={{ paddingTop: 8 }}>
													{SelectGroup && SelectGroup.length > 0 ?
														<ChipArrayRed chipData={SelectGroup} key1={'ID'} key2={`Title`} handleDelete={handleDeleteVers} />
														: ''}
												</Grid>
											</FormControl>

											<FormControl component="fieldset" style={{ maxWidth: 285, width: '100%' }}>
												<Typography className={classes.header}>{translate.Words[`SubGroup${language}`]}:</Typography>

												<ProdDirectionSubFilterList
													data={BranchArr}
													ids={SelectBranch}
													key1={'ID'}
													key2={`Title${language}`}
													setBefore={setSelectBranch}
													header={translate.Words[`SubGroup${language}`]}
													paramName='direction'
													close={() => setScreenDirectionVisible(!screenDirectionVisible)}
												/>

												{SelectBranch && SelectBranch.length > 0 ?
													<Grid item style={{ paddingTop: 8 }}>
														<ChipArrayRed chipData={SelectBranch} key1={'ID'} key2={`Title${language}`} handleDelete={removeSubFroup} />
													</Grid> : ''}
											</FormControl>
										</Grid>
										<Grid item className={classes.FilterActionCntr}>
											<FilterButton variant="contained" className={classes.btnSecondary} onClick={() => resetState()}>{translate.Words[`ResetFilters${language}`]} </FilterButton>
										</Grid>
									</Grid>
								</Grid>
							</Drawer>
						</Grid>
						{/* =============== ФИЛЬТРЫ ===== */}
					</Grid>

					{
						(statusFilter || findText !== '') && !loading
							?
							//<Typography className={classes.FoundProds}>{translate.Words[`FoundProds${language}`]}{cardArrAll.length}</Typography>
							renderSearchInfo()
							:
							''
					}
				</Grid>

				<ApplicationsContent />
			</Grid>

			{
				view !== 'tbl'
					?
					<Grid item container style={{ display: Math.trunc((countApp - 1) / 24) > 0 ? '' : 'none', marginTop: 24, paddingLeft: 13, alignItems: 'center' }} >
						<Pagination className={classes.newPagination} count={Math.trunc((countApp - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
					</Grid>
					:
					null
			}
			{
				view !== 'tbl'
					?
					<Grid item id='paginationContainer-js' container style={{ display: Math.trunc((countApp - 1) / 24) > 0 ? '' : 'none', marginTop: 24, height: 64, position: 'fixed', bottom: '0px', background: '#F4F5FB', paddingLeft: 13, alignItems: 'center' }} >
						<Pagination className={classes.newPagination} count={Math.trunc((countApp - 1) / 24) + 1} page={page} siblingCount={window.innerWidth < 696 ? 0 : 1} onChange={changePage} />
					</Grid>
					:
					null
			}

			<div>
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					open={snackbar[0]}
					autoHideDuration={3000}
					onClose={closeSnackbar}
				// message="Приложение доавлено в корзину"
				// className={classes.root}
				>
					<Grid
						container
						direction="row"
						justify="flex-start"
						alignItems="center"
						className={classes.snackbarPostroot}
					>
						<Avatar style={{ height: 48, width: 48, background: 'rgba(255, 255, 255, 0.2)' }}>
							<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.75488 12.2105L10.7894 16L19.7549 7" stroke="white" stroke-width="2" stroke-linecap="round" />
							</svg>
						</Avatar>

						<Typography style={{ marginLeft: 16, fontFamily: 'Cera CY', fontStyle: 'normal', fontWeight: '500', fontSize: '18px', lineHeight: '28px', color: '#FFFFFF', width: 'calc(100% - 64px)' }}>
							{translate.Words[`ProductsHaveBeenAddedToTheCart${language}`] + ': ' + snackbar[1]}
						</Typography>
					</Grid>
				</Snackbar>
			</div>

		</React.Fragment>
	);
}

const StyledBadge = withStyles((theme) => ({
	badge: {
		top: 32,
		right: -6,
		height: 10,
		width: 10,
		borderRadius: 5,
		backgroundColor: '#EB505E'
	},
}))(Badge);


const useStyles = makeStyles(theme => ({
	// root: {
	// 	display: "flex"
	// },

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	content: {
		flexGrow: 1,
		padding: 0,
		paddingTop: theme.spacing(3),
		marginTop: theme.spacing(12),
		// backgroundColor: 'inherit'
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	container: {
		margin: '72px auto 0',
		'&:first-child': {
			margin: '0 auto'
		},
		[theme.breakpoints.down(696)]: {
			maxWidth: 'calc(336px * 1)',
		},
		[theme.breakpoints.between(696, 1030)]: {
			maxWidth: 'calc(336px * 2)',
		},
		[theme.breakpoints.between(1030, 1366)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.between(1366, 1702)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.up(1702)]: {
			maxWidth: 'calc(336px * 4)',
		}
	},

	containerImage: {
		[theme.breakpoints.down(1702)]: {
			minWidth: '100%',
		},
	},

	containerInfo: {
		[theme.breakpoints.down(1702)]: {
			display: 'none',
		},
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemText: {
		padding: theme.spacing(1, 1)
	},

	paper: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2)
	},

	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},

	imgCntr: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		backgroundImage: 'url(./images/BannerDesctop.png)',
		borderRadius: 24
	},

	footer: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '36px 0'
	},

	btnFilter: {
		backgroundColor: '#FFF',
		borderRadius: '16px',
		'&:focus': {
			borderRadius: '16px'
		}
	},

	tHeader: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		fontWeight: 400
	},

	backToList: {
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	search: {
		flexGrow: 1,
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		padding: '0 12px',
		width: 'auto',
		height: 48,

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		},

		[theme.breakpoints.down(696)]: {
			marginBottom: theme.spacing(1),
		},
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},

	inputRoot: {
		color: '#8987A2',
		// outline: '1px solid purple',
		width: '100%'
	},

	inputFocused: {
		color: '#8987A2',
		// outline: '1px solid green',
		width: '100%'
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
		paddingRight: 48,
		transition: theme.transitions.create('width'),
		width: '100%',
		height: 32,

		[theme.breakpoints.up(1366)]: {
			// width: 0,
			'&:focus': {
				width: '100%',
			},
		},

		[theme.breakpoints.down(1366)]: {
			// width: 0,
			'&:focus': {
				// width: 207,
				width: '100%',
			},
		},
		color: '#8987A2'
	},

	root: {
		flexGrow: 1
	},
	padding: {
		padding: theme.spacing(1)
	},
	demo1: {
		backgroundColor: theme.palette.background.paper
	},
	demo2: {
		backgroundColor: "#2e1534"
	},

	cntrAppCardTop: {
		padding: '36px 0'
	},

	cntrChangeView: {
		marginRight: 23,

		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	},

	inputCloseBtn: {
		position: 'absolute',
		top: 0,
		right: 0,

		// [theme.breakpoints.up(1365)]: {
		// 	display: 'none'
		// }
	},

	inputCloseBtnHide: {
		display: 'none'
	},

	filterHeader: {
		fontWeight: 500,
		fontSize: '24px',
		lineHeight: '32px',
		color: '#24262A'
	},

	header: {
		marginTop: 20,
		marginBottom: 10,
		fontWeight: 500,
		fontSize: '18px',
		lineHeight: '28px',
		color: '#24262A'
	},

	FilterActionCntr: {
		padding: '24px 0 0 0'
	},

	FilterBodyCntr: {
		height: 'calc(100% - 75px)',
		overflowX: 'hidden',
		overflowY: 'auto',
		width: 285,
		flexFlow: 'column',
		scrollbarWidth: 'thin'
	},

	snackbarPostroot: {
		padding: 24,
		borderRadius: '16px',
		background: 'rgba(60, 60, 86, 0.9)',
	},

	FoundProds: {
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "24px",
		lineHeight: "32px",
		color: "#000000",
		padding: "16px 0px",
	},
	newPagination: {
		display: 'flex',
		alignItems: 'center'
	}
}));

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3} style={{ padding: 0, backgroundColor: 'transparent' }} >
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);